import { useQuery } from '@tanstack/react-query';

import { contactsRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useContactsCount = () => {
  const query = useQuery({
    queryKey: [QueryKeys.CONTACTS_COUNT],
    queryFn: () => contactsRepo.getContactsCount(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseContactsCount = ReturnType<typeof useContactsCount>;
